import axios from 'axios';
import { Network } from '@yme/services/network';
import { getPreloadedModel, isPreloaded } from './preloader';
export function requestAPI(config, payload) {
    return (dispatch) => {
        const SUCCESS_REQUEST = `${config.actionType}_SUCCESS`;
        const FAILURE_REQUEST = `${config.actionType}_FAILURE`;
        const urlPath = new URL(config.url).pathname;
        if (isPreloaded(urlPath)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const result = getPreloadedModel(urlPath);
            return result
                .then((data) => {
                dispatch({
                    type: SUCCESS_REQUEST,
                    payload: {
                        data,
                    },
                });
            })
                .catch((error) => {
                dispatch({
                    type: FAILURE_REQUEST,
                    error,
                });
            });
        }
        dispatch({
            type: `${config.actionType}_REQUEST`,
            payload,
        });
        return Network.get(config.url, config)
            .then((response) => {
            dispatch({
                type: SUCCESS_REQUEST,
                payload: response,
            });
        })
            .catch((error) => {
            dispatch({
                type: FAILURE_REQUEST,
                error,
            });
        });
    };
}
// TODO: need to fix type for serviceAPI
export function serviceAPI(config, actions, meta) {
    return (dispatch) => {
        if (actions.request) {
            dispatch(actions.request());
        }
        return axios(config)
            .then((response) => {
            if (actions.success) {
                dispatch(actions.success(response, meta));
            }
            if (actions.successCb) {
                actions.successCb(response);
            }
        })
            .catch((error) => {
            if (actions.failure) {
                dispatch(actions.failure(error));
            }
            if (actions?.failureCb) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                dispatch(actions.failureCb(error));
            }
        });
    };
}
